var analyticsProvidersExtensions = {
  'mixpanel': 'Autodesk.Viewing.MixpanelExtension' };


var namespace = AutodeskNamespace('Autodesk.Viewing.Private.analytics');
namespace.ProvidersExtensions = analyticsProvidersExtensions;

export {
analyticsProvidersExtensions };